import React from 'react';

export function Arrow(props) {
  return (
    <svg className={`svg arrow ${props.className || ''}`} version="1.1" id="Arrow-3" x="20px" y="14px" viewBox="0 0 30 22">
	    <path d="M29.706,10l-10-10l-1.414,1.414l8.293,8.293H0v2h26.584L18.292,20l1.414,1.414l10-10C30.096,11.023,30.096,10.391,29.706,10z"/>
    </svg>

  )
}